module.exports = __webpack_public_path__ + "assets/img/timeLine_img4.99a608f6.png";